import React, { useState } from 'react';
import { Card, CardHeader, CardContent, Typography, Stack, Tooltip, Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Buffer } from 'buffer';
import { Icon } from '@iconify/react';
import bookMark from '@iconify/icons-eva/bookmark-outline';
import bookFill from '@iconify/icons-eva/book-outline';
import clockFill from '@iconify/icons-eva/clock-outline';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import { LoadingButton } from '@mui/lab';
import { getValue } from 'firebase/remote-config';
import { capturePHEvents } from '../analytics/posthog.analytics';
import palette from '../theme/palette';
import typography from '../theme/typography';
import { CheckClassIsOnline, GetDurationBetweenTwoDate } from '../helper/commonHelper';
import { getCke } from '../helper/cookieHelper';
import '../css/classCard.css';
import { createAttendance } from '../service/attendance.service';
import Label from '../fl-components/Label';
import { PH_CLASS_CLICKED, PH_JOIN_CLASS } from '../utils/posthog.eventNames';
import { remoteConfig } from '../firebase/firebase';
import { SET_SELECTED_CLASS } from '../redux/constants';

const useStyles = makeStyles({
  title: {
    fontSize: 14
  },
  iconAndText: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 10
  },
  dotStyle: {
    marginLeft: 10,
    width: 5,
    height: 5,
    borderRadius: '50%',
    backgroundColor: palette.grey[600]
  },
  cardBodyText: {
    marginLeft: 10,
    textTransform: 'capitalize',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    ...typography.body2
  },
  bottomClassNameBar: {
    backgroundColor: palette.secondary.main,
    color: 'white',
    paddingBottom: 2,
    paddingTop: 15,
    textAlign: 'center',
    borderBottomLeftRadius: 16,
    borderBottomRightRadius: 16,
    position: 'absolute',
    width: '100%',
    zIndex: -1,
    bottom: -26,
    fontStyle: 'italic'
  },
  dayContainer: {
    fontWeight: 'bold',
    fontSize: 15,
    margin: '0 2px'
  }
});

// const theme = createTheme({
//   components: {
//     MuiAvatarGroup: {
//       styleOverrides: {
//         avatar: {
//           height: '30px',
//           width: '30px'
//         }
//       }
//     }
//   }
// });

export default function ClassCard({ classData }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // User from redux
  const currentUser = useSelector((state) => state.auth.currentUser);
  // Notification
  const { enqueueSnackbar } = useSnackbar();
  // Button Loading State
  const [loadingButton, setLoadingButton] = useState(false);
  // Remote config value
  const isShowClassAllTime = getValue(remoteConfig, 'isShowClassAllTime');

  // const [displayGreenDot, setGreenDot] = useState(false);
  // const [refreshAfter, setRefreshAfter] = useState();

  // TO-DO: this is comment for display weekday in the right of the class card
  // const getClassDay = (schedules) => {
  //   const data = [];
  //   schedules.map((day) => {
  //     if (day.selected) {
  //       data.push(
  //         <Tooltip title={day.day}>
  //           <div
  //             className={classes.dayContainer}
  //             style={{
  //               borderColor: `${SEVEN_DAY_COLOR[day.day.toLowerCase()]}`,
  //               color: `${SEVEN_DAY_COLOR[day.day.toLowerCase()]}`
  //             }}
  //           >
  //             {day.day.charAt(0)}
  //           </div>
  //         </Tooltip>
  //       );
  //     }
  //     return null;
  //   });
  //   return data;
  // };

  // setTimeout(() => {
  //   displayCurrentTime(classData.schedule);
  //   setGreenDot(false);
  // }, refreshAfter);

  const displayCurrentTime = (schedules) => {
    let displayTime = '';
    let greenDot = false;
    schedules.forEach((day) => {
      if (day.day === moment().format('dddd') && day.selected) {
        // Get today day with time 12 am in morning
        // For ex: 16/07/2022 12:00 am
        const todayDateWhenDayStart = moment().hour(0).minute(0).second(0).toISOString();
        for (let i = 0; i < day.slots.length; i += 1) {
          // Comparing hour of current time with start and end time.
          const slot = day.slots[i];

          const classBeginningTime = moment(todayDateWhenDayStart)
            .add(moment(slot.from).hour(), 'hour')
            .add(moment(slot.from).minute(), 'minute');
          const classEndTime = moment(todayDateWhenDayStart)
            .add(moment(slot.to).hour(), 'hour')
            .add(moment(slot.to).minute(), 'minute');
          const currentTime = moment();

          if (currentTime.isAfter(classBeginningTime) && greenDot) {
            // setGreenDot(false);
            greenDot = false;
          }
          if (currentTime.isAfter(classEndTime)) {
            // First we check the current time slot is ended or not.
            // If yes then we going to fetch next slot details
            // eslint-disable-next-line
            continue;
          } else if (
            currentTime.isAfter(classBeginningTime) &&
            currentTime.isBefore(classEndTime) &&
            !greenDot
          ) {
            // const milliseconds = classEndTime.diff(classBeginningTime, 'milliseconds');
            // setRefreshAfter(milliseconds);
            // Second we check that is current slot is running then we active the green dot and going to fetch next slot details
            // setGreenDot(true);
            displayTime = (
              <Tooltip
                title={`${moment(slot.from).format('LT').replace('M', '')} - ${moment(slot.to)
                  .format('LT')
                  .replace('M', '')}, ${GetDurationBetweenTwoDate(slot.from, slot.to)}`}
                placement="bottom-start"
                arrow
              >
                <Box component="span" display="flex" alignItems="center" width="90%">
                  <p className={classes.cardBodyText}>
                    {moment(slot.from).format('LT').replace('M', '')} -{' '}
                    {moment(slot.to).format('LT').replace('M', '')}
                  </p>{' '}
                  <div className={classes.dotStyle} />{' '}
                  <p className={classes.cardBodyText}>
                    {GetDurationBetweenTwoDate(classBeginningTime, classEndTime)}
                  </p>
                </Box>
              </Tooltip>
            );
            greenDot = true;
            // eslint-disable-next-line
            // continue;
            break;
          } else if (currentTime.isBefore(classBeginningTime)) {
            // Third we check that class is about to start then we display current timing and break the loop here.
            displayTime = (
              <Tooltip
                title={`${moment(slot.from).format('LT').replace('M', '')} - ${moment(slot.to)
                  .format('LT')
                  .replace('M', '')}, ${GetDurationBetweenTwoDate(slot.from, slot.to)}`}
                placement="bottom-start"
                arrow
              >
                <Box component="span" display="flex" alignItems="center" width="90%">
                  <p className={classes.cardBodyText}>
                    {moment(slot.from).format('LT').replace('M', '')} -{' '}
                    {moment(slot.to).format('LT').replace('M', '')}
                  </p>{' '}
                  <div className={classes.dotStyle} />{' '}
                  <p className={classes.cardBodyText}>
                    {GetDurationBetweenTwoDate(classBeginningTime, classEndTime)}
                  </p>
                </Box>
              </Tooltip>
            );
            break;
          }
        }
        if (displayTime === '' && day.slots.length) {
          const slot = day.slots[day.slots.length === 1 ? 0 : day.slots.length - 1];
          displayTime = (
            <Tooltip
              title={`${moment(slot.from).format('LT').replace('M', '')} - ${moment(slot.to)
                .format('LT')
                .replace('M', '')}, ${GetDurationBetweenTwoDate(slot.from, slot.to)}`}
              placement="bottom-start"
              arrow
            >
              <Box component="span" display="flex" alignItems="center" width="90%">
                <p className={classes.cardBodyText}>
                  {moment(slot.from).format('LT').replace('M', '')} -{' '}
                  {moment(slot.to).format('LT').replace('M', '')}
                </p>{' '}
                <div className={classes.dotStyle} />{' '}
                <p className={classes.cardBodyText}>
                  {GetDurationBetweenTwoDate(
                    moment(todayDateWhenDayStart)
                      .add(moment(slot.from).hour(), 'hour')
                      .add(moment(slot.from).minute(), 'minute'),
                    moment(todayDateWhenDayStart)
                      .add(moment(slot.to).hour(), 'hour')
                      .add(moment(slot.to).minute(), 'minute')
                  )}
                </p>
              </Box>
            </Tooltip>
          );
        }
      }
    });
    if (displayTime === '') {
      displayTime = <p className={classes.cardBodyText}>No class today</p>;
    }
    return { displayTime, greenDot };
  };

  return (
    <Card
      style={{ zIndex: 'unset' }}
      onClick={() => {
        capturePHEvents(PH_CLASS_CLICKED, {
          classData,
          userData: currentUser
        });
        dispatch({ type: SET_SELECTED_CLASS, payload: classData });
        navigate(`/dashboard/classes/${classData.id}`, {
          replace: true,
          state: {
            classData
          }
        });
      }}
    >
      <img
        src={classData?.bannerUrl ?? ''}
        style={{ width: '100%', height: 'auto' }}
        alt={`${classData.name} - banner`}
      />
      <CardHeader
        sx={{ '.MuiCardHeader-content': { width: '100%' } }}
        title={
          <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
            <Tooltip title={classData.name} placement="top-start">
              <Typography noWrap fontWeight={700} fontSize="1.125rem">
                {classData.name}
              </Typography>
            </Tooltip>
            {displayCurrentTime(classData.schedule).greenDot ? (
              <div className="blinking-dot" />
            ) : (
              classData.isUpcoming && <Label>Today</Label>
            )}
          </Stack>
        }
        // subheader={`Number of students : ${classData.sample}`}
        // action={<div style={{ display: 'flex' }}>{getClassDay(classData.schedule)}</div>}
      />
      <CardContent style={{ paddingTop: '5px' }}>
        <div className={classes.iconAndText}>
          <Icon icon={bookMark} width={22} height={22} />{' '}
          <p className={classes.cardBodyText}>{classData.category}</p>
        </div>
        <div className={classes.iconAndText}>
          <Icon icon={bookFill} width={22} height={22} />{' '}
          <p className={classes.cardBodyText}>{classData.subject}</p>
        </div>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mt="10px">
          <div className={classes.iconAndText} style={{ marginTop: 0, width: '76%' }}>
            <Icon icon={clockFill} width={22} height={22} />{' '}
            {displayCurrentTime(classData.schedule).displayTime}
          </div>
          {(CheckClassIsOnline(classData.schedule) !== null || isShowClassAllTime.asBoolean()) && (
            <LoadingButton
              variant="contained"
              loading={loadingButton}
              onClick={async (e) => {
                e.preventDefault();
                e.stopPropagation();
                setLoadingButton(true);
                capturePHEvents(PH_JOIN_CLASS, {
                  classData,
                  userData: currentUser
                });
                const attendanceObj = {
                  orgId: classData.orgId._id,
                  type: 'online',
                  slotId: CheckClassIsOnline(classData.schedule)._id,
                  slot: `slot${
                    classData.schedule.findIndex(
                      (ts) => ts._id === CheckClassIsOnline(classData.schedule)._id
                    ) + 1
                  }`,
                  slotTimeFrom: CheckClassIsOnline(classData.schedule).from,
                  slotTimeTo: CheckClassIsOnline(classData.schedule).to,
                  presentStudents: [currentUser?.id],
                  absentStudents: []
                };
                const res = await createAttendance(classData.id, attendanceObj);
                if (res) {
                  const obj = {
                    atk: getCke('accessToken'),
                    userName: currentUser?.fullName,
                    userRole: currentUser?.profile,
                    userId: currentUser?.id
                  };
                  const encodedObj = Buffer.from(JSON.stringify(obj)).toString('base64');
                  setLoadingButton(false);
                  window.open(
                    `${process.env.REACT_APP_ZOOM_REDIRECT_URL}/joinClass/${classData.id}?fud=${encodedObj}`
                  );
                } else {
                  enqueueSnackbar('Something went wrong, Please try again', {
                    variant: 'error'
                  });
                  setLoadingButton(false);
                }
              }}
            >
              Join
            </LoadingButton>
          )}
        </Stack>
        {/* <div
          style={{
            display: 'flex',
            justifyContent: `${classData?.studentCount !== 0 ? 'space-between' : 'flex-end'}`,
            alignItems: 'center',
            marginTop: 15
          }}
        >
          {classData?.studentCount !== 0 && (
            <ThemeProvider theme={theme}>
              <AvatarGroup max={3}>
                {Array.from(Array(classData?.studentCount).keys()).map((a, i) => (
                  <Avatar
                    key={i}
                    alt="Remy Sharp"
                    sx={{ width: 30, height: 30 }}
                    src="https://avatars.dicebear.com/v2/avataaars/ab93a4a9c3907cf23ddc0f314ca2caa8.svg"
                  />
                ))}
              </AvatarGroup>
            </ThemeProvider>
          )}
          {(CheckClassIsOnline(classData.schedule) !== null || CODE_CONFIG.isShowClassAllTime) && (
            <LoadingButton
              variant="contained"
              loading={loadingButton}
              onClick={async (e) => {
                e.preventDefault();
                e.stopPropagation();
                setLoadingButton(true);
                const attendanceObj = {
                  orgId: selectedOrg?.orgId || selectedOrg?.id,
                  type: 'online',
                  slotId: CheckClassIsOnline(classData.schedule)._id,
                  slot: `slot${
                    classData.schedule.findIndex(
                      (ts) => ts._id === CheckClassIsOnline(classData.schedule)._id
                    ) + 1
                  }`,
                  slotTimeFrom: CheckClassIsOnline(classData.schedule).from,
                  slotTimeTo: CheckClassIsOnline(classData.schedule).to,
                  presentStudents: [currentUser?.id],
                  absentStudents: []
                };
                const res = await createAttendance(classData.id, attendanceObj);
                if (res) {
                  const obj = {
                    atk: getCke('accessToken'),
                    userName: currentUser?.fullName,
                    userRole: currentUser?.profile,
                    userId: currentUser?.id
                  };
                  const encodedObj = Buffer.from(JSON.stringify(obj)).toString('base64');
                  setLoadingButton(false);
                  window.open(
                    `${process.env.REACT_APP_ZOOM_REDIRECT_URL}/joinClass/${classData.id}?fud=${encodedObj}`
                  );
                } else {
                  enqueueSnackbar('Something went wrong, Please try again', {
                    variant: 'error'
                  });
                  setLoadingButton(false);
                }
              }}
            >
              Join Class
            </LoadingButton>
          )}
        </div> */}
      </CardContent>
      <div className={classes.bottomClassNameBar}>
        <b>Classroom of</b> {classData?.orgId.name}
      </div>
    </Card>
  );
}

ClassCard.propTypes = {
  classData: PropTypes.shape({
    bannerUrl: PropTypes.string,
    name: PropTypes.string,
    id: PropTypes.string,
    category: PropTypes.string,
    subject: PropTypes.string,
    isUpcoming: PropTypes.bool,
    orgId: PropTypes.shape({
      name: PropTypes.string,
      _id: PropTypes.string
    }),
    studentCount: PropTypes.number,
    schedule: PropTypes.arrayOf(
      PropTypes.shape({
        day: PropTypes.string,
        selected: PropTypes.bool,
        slots: PropTypes.arrayOf(
          PropTypes.shape({
            from: PropTypes.string,
            to: PropTypes.string
          })
        )
      })
    )
  })
};
